module.exports = __webpack_public_path__ + "img/offline.bc7f6d61.svg";